export default __webpack_public_path__ + "static/media/HASSAN_NL_INTRO.ce2b5167.mp3";